<div #scrollBody >

<ng-content>
</ng-content>

</div>
